import React from 'react';
import { doc, updateDoc, arrayRemove } from 'firebase/firestore';
import CommentList from '../CommentList';
import RecommendationList from './RecommendationList/RecommendationList';
import ConfirmDeleteDialog from '../ConfirmDeleteDialog/ConfirmDeleteDialog';
import styles from './SongPage.module.scss';
import logger from '../../utils/logger';

const CommentSection = ({
  songDetails,
  setSongDetails,
  currentUser,
  handleAddComment,
  handleDeleteComment,
  handleDeleteReply,
  handleAddReply,
  handleLikeComment,
  handleUnlikeComment,
  handleLikeReply,
  handleUnlikeReply,
  showConfirmDialog,
  confirmDelete,
  setShowConfirmDialog,
  commentFormRef,
  handleUserPageNavFromSong,
  db,
  recommendationsRef,
  commentSectionRef,
  highlightCommentId,
  highlightReplyId,
}) => {
  const handleDeleteRecommendation = async (recommendation) => {
    try {
      const songRef = doc(db, 'songs', songDetails.id);
      await updateDoc(songRef, {
        recommendations: arrayRemove(recommendation),
      });
      setSongDetails((prev) => ({
        ...prev,
        recommendations: prev.recommendations.filter(
          (rec) => rec.url !== recommendation.url
        ),
      }));
    } catch (error) {
      logger.error('Error deleting recommendation:', error);
    }
  };

  return (
    <div className={styles.body} ref={commentSectionRef}>
      {showConfirmDialog && (
        <ConfirmDeleteDialog
          message="Are you sure you want to delete this song?"
          show={showConfirmDialog}
          onClose={() => setShowConfirmDialog(false)}
          confirm={confirmDelete}
        />
      )}
      <div ref={recommendationsRef}>
        {Array.isArray(songDetails.recommendations) && (
          <RecommendationList
            recommendations={songDetails.recommendations}
            currentUser={currentUser}
            onDelete={handleDeleteRecommendation}
          />
        )}
      </div>
      {Array.isArray(songDetails.comments) && (
        <CommentList
          comments={songDetails.comments}
          currentUser={currentUser}
          onDelete={handleDeleteComment}
          onDeleteReply={handleDeleteReply}
          onAddReply={handleAddReply}
          onLikeComment={handleLikeComment}
          onUnlikeComment={handleUnlikeComment}
          onLikeReply={handleLikeReply}
          onUnlikeReply={handleUnlikeReply}
          songId={songDetails.id}
          handleUserPageNavFromSong={handleUserPageNavFromSong}
          highlightCommentId={highlightCommentId}
          highlightReplyId={highlightReplyId}
        />
      )}
    </div>
  );
};

export default CommentSection;
